import WidgetHeaderWide from './WidgetHeaderWide';
export default WidgetHeaderWide;
